import { toast } from "react-toastify";
import { ictDetailsService } from "../service";
import {
  setIctInventoryData,
  setIctDetailsLoading,
  setIctDetailsError,
  setIctInventoryResponseData,
  setIctInventoryPartialAnswersData,
  setIctEvaluationData,
  setIctEvaluationConfirmData,
  setIctEvaluationPartialAnswersData,
  setIctEvaluationResponseData,
  setIctFollowupDetailsData,
  setIctFollowupPartialAnswersData,
  setIctFollowupResponseData,
} from "../slice/ictDetailsSlice";

const getIctInventoryDetailsAsync = (inventory_id, t) => async (dispatch) => {
    dispatch(setIctDetailsLoading());
    try {
      const response = await ictDetailsService.getIctInventoryDetails(inventory_id);
      if(response.status === 500){
        toast.error(t(1905));
        dispatch(setIctDetailsError(response));
      }
      else if (response?.data?.error || response?.data?.Error) {
        toast.error(t(response?.data?.error.error_code,{toastId: 129}));
        dispatch(setIctDetailsError(response));
      } else {
        dispatch(setIctInventoryData(response.data));
        dispatch(setIctDetailsError({}));
      }
    } catch (error) {
      dispatch(setIctDetailsError(error));
    }
}
const addIctInventoryAnswerAsync = (inventory_id, data, t, navigate, resultsPath) => async (dispatch) => {

    dispatch(setIctDetailsLoading())
    try {
      const response = await ictDetailsService.addIctInventoryAnswer(inventory_id, data);
      if(response.status === 500){
        toast.error(t(1905));
        dispatch(setIctDetailsError(response));
        return false;
      }
      else if (response?.data?.error || response?.data?.Error) {
        toast.error(t(response?.data?.error?.error_code));
        dispatch(setIctDetailsError(response));
        return false;
      } else {
        navigate(
          resultsPath || `/participants/ict/initial-inventories/${inventory_id}/results`,
          { replace: true },
        );
        dispatch(setIctDetailsError({}));
        return true;
      }
    } catch (error) {
      dispatch(setIctDetailsError(error));
      return false;
    }
  };
  const getIctInventoryResultsAsync = (inventory_id,t) => async (dispatch) => {
    dispatch(setIctInventoryResponseData({}));
    dispatch(setIctDetailsLoading())
    try {
      const response = await ictDetailsService.getIctInventoryAnswer(inventory_id);
      if(response.status === 500){
        toast.error(t(1905));
        dispatch(setIctDetailsError(response));
      }
      else if (response?.data?.error || response?.data?.Error) {
        const apiError = response?.data?.error || response?.data?.Error;
        if (response.status === 400) {
          toast.error(t(apiError?.error_code));
        }
        dispatch(setIctDetailsError(response));
      } else {
        dispatch(setIctInventoryResponseData(response.data));
        dispatch(setIctDetailsError({}));
      }
    } catch (error) {
      dispatch(setIctDetailsError(error));
    }
  };
  const getIctInventoryPartialAnswersAsync = (inventory_id,t) => async (dispatch) => {
    dispatch(setIctInventoryPartialAnswersData({}))
    try {
      const response = await ictDetailsService.getIctInventoryPartialAnswers(inventory_id);
      if(response.status === 500){
        toast.error(t(1905));
        dispatch(setIctDetailsError(response));
        return false ;
      }
      else if (response?.data?.error || response?.data?.Error) {
        if(response?.data?.error.error_code === 9040){
          return;
        }
        const error = response?.data?.error || response?.data?.Error;
        if(error?.error_code === 4043){
          toast.error(t(error?.error_code));
        }
        dispatch(setIctDetailsError(response));
        return false;
      } else {
        dispatch(setIctDetailsError({}));
        dispatch(setIctInventoryPartialAnswersData(response));
      }
    } catch (error) {
      dispatch(setIctDetailsError(error));
      return false ;
    }
  };
  
  const addIctInventoryPartialAnswersAsync = (inventory_id, data,t) => async (dispatch) => {
    try {
      const response = await ictDetailsService.addIctInventoryPartialAnswers(inventory_id, data);
      const apiError = response?.data?.error || response?.data?.Error;

      if(response.status === 500){
        toast.error(t(1905));
        dispatch(setIctDetailsError(response));
        return { success: false, error: apiError };
      }
      else if (apiError) {
        if(apiError?.error_code === 4043){
          toast.error(t(apiError?.error_code),{toastId: 129});
        }
        dispatch(setIctDetailsError(response));
        return { success: false, error: apiError };
      } else {
        dispatch(setIctDetailsError({}));
        return { success: true };
      }
    } catch (error) {
      dispatch(setIctDetailsError(error));
      return { success: false };
    }
  };

const UpdateIctInventoryAnswerPageAsync = (inventory_id, dataToSave,t) => async (dispatch) => {
    try {
        const response = await ictDetailsService.updateIctInventoryAnswerPage(inventory_id, dataToSave);
        if(response.status === 500){
            toast.error(t(1905));
            dispatch(setIctDetailsError(response));
            return false;
        }
        else if (response?.data?.error || response?.data?.Error) {
            toast.error(t(response?.data?.error.error_code),{toastId: 129});
            dispatch(setIctDetailsError(response));
            return false;
        } else {
            dispatch(setIctDetailsError({}));
            return true;
        }
    } catch (error) {
        dispatch(setIctDetailsError(error));
        return false;
    }
};
/* ICT Evaluation */

const getIctEvaluationDetailsAsync = (workshop_id, t) => async (dispatch) => {
  dispatch(setIctEvaluationData({}));
  dispatch(setIctDetailsLoading())
  try {
    const response = await ictDetailsService.getIctEvaluationDetails(workshop_id);
    if(response.status === 500){
      toast.error(t(1905));
      dispatch(setIctDetailsError(response));
    }
    else if (response?.data?.error || response?.data?.Error) {
      toast.error(t(response?.data?.error?.error_code));
      dispatch(setIctDetailsError(response));
    } else {
      dispatch(setIctEvaluationData(response));
      dispatch(setIctDetailsError({}));
    }
  } catch (error) {
    dispatch(setIctDetailsError(error));
  }
};

const addIctEvaluationAnswerAsync = (workshop_id, data,t, navigate) => async (dispatch) => {
  
  dispatch(setIctDetailsLoading())
  try {
    const response = await ictDetailsService.addIctEvaluationAnswer(workshop_id, data);
    if(response.status === 500){
      toast.error(t(1905));
      dispatch(setIctDetailsError(response));
    }
    else if (response?.data?.error || response?.data?.Error) {
      const apiError = response?.data?.error || response?.data?.Error;
      toast.error(t(apiError?.error_code));
      dispatch(setIctDetailsError(response));
    } else {
      navigate(`/participants/ict/evaluations/${workshop_id}/results`, { replace: true })
      dispatch(setIctEvaluationConfirmData({}))
       dispatch(setIctEvaluationData({}));
      dispatch(setIctDetailsError({}));
    }
  } catch (error) {
    dispatch(setIctDetailsError(error));
  }
};

const getIctEvaluationPartialAnswersAsync = (workshop_id,t) => async (dispatch) => {
  dispatch(setIctEvaluationPartialAnswersData({}));
  dispatch(setIctDetailsLoading())
  try {
    const response = await ictDetailsService.getIctEvaluationPartialAnswers(workshop_id);
    if(response.status === 500){
      toast.error(t(1905));
      dispatch(setIctDetailsError(response));
    }
    else if (response?.data?.error || response?.data?.Error) {
      const apiError = response?.data?.error;
      toast.error(t(apiError?.error_code));
      dispatch(setIctDetailsError(response));
    } else {
      dispatch(setIctEvaluationPartialAnswersData(response.data));
      dispatch(setIctDetailsError({}));
    }
  } catch (error) {
    dispatch(setIctDetailsError(error));
  }
};
const updateIctEvaluationAnswerPageAsync = (workshopId, dataToSave, t) => async (dispatch) => {
  try {
    const response = await ictDetailsService.updateIctEvaluationAnswerPage(
      workshopId,
      dataToSave,
    );
    if (response.status === 500) {
      toast.error(t(1905));
      dispatch(setIctDetailsError(response));
      return false;
    } else if (response?.data?.error || response?.data?.Error) {
      const apiError = response?.data?.error;
      toast.error(t(apiError?.error_code));
      dispatch(setIctDetailsError(response));
      return false;
    } else {
      dispatch(setIctDetailsError({}));
      return true;
    }
  } catch (error) {
    dispatch(setIctDetailsError(error));
    return false;
  }
};
const addIctEvaluationPartialAnswersAsync = (workshopId, data,t) => async (dispatch) => {
  try {
    const response = await ictDetailsService.addIctEvaluationPartialAnswers(workshopId, data);
    const apiError = response?.data?.error;

    if(response.status === 500){
      toast.error(t(1905));
      dispatch(setIctDetailsError(response));
    }
    else if (apiError) {
      if(apiError.error_code === 4043){
        toast.error(t(apiError?.error_code));
      }
      dispatch(setIctDetailsError(response));
    } else {
      dispatch(setIctDetailsError({}));
    }
  } catch (error) {
    dispatch(setIctDetailsError(error));
  }
};
const getIctEvaluationResultsAsync = (workshop_id,t) => async (dispatch) => {

  dispatch(setIctDetailsLoading())
  try {
    const response = await ictDetailsService.getIctEvaluationAnswer(workshop_id);
    if(response.status === 500){
      toast.error(t(1905));
      dispatch(setIctDetailsError(response));
    }
    else if (response?.data?.error || response?.data?.Error) {
      const apiError = response?.data?.error || response?.data?.Error;
      if (response.status === 400) {
        toast.error(t(apiError?.error_code));
      }
      dispatch(setIctDetailsError(response));
    } else {
      dispatch(setIctEvaluationResponseData(response));
      dispatch(setIctDetailsError({}));
    }
  } catch (error) {
    dispatch(setIctDetailsError(error));
  }
};
// ICT Followup
const getIctFollowupDetailsAsync = (followupId, t) => async (dispatch) => {
  dispatch(setIctDetailsLoading());
  try{
    const response = await ictDetailsService.getIctFollowupDetails(followupId);
    if(response.status === 500){
      dispatch(setIctDetailsError(response));
    }
    else if (response?.data?.error || response?.data?.Error){
      toast.error(t(response?.data?.error.error_code));
      dispatch(setIctDetailsError(response));
    }
    else {
      dispatch(setIctFollowupDetailsData(response));
      dispatch(setIctDetailsError({}));
    }
  }
  catch(error) {
    dispatch(setIctDetailsError(error));
  }
 };

const addIctFollowupPartialAnswersAsync = (followup_id, data, t) => async (dispatch) => {
  try {
    const response = await ictDetailsService.addIctFollowupPartialAnswers(followup_id, data);
    if(response.status === 500){
      toast.error(t(1905));
      dispatch(setIctDetailsError(response));
    }
    else if (response?.data?.error || response?.data?.Error) {
      if(response?.data?.error.error_code === 4043){
        toast.error(t(response?.data?.error.error_code));
      }
      dispatch(setIctDetailsError(response));
    }
  }
  catch(error) {
    dispatch(setIctDetailsError(error));
  }
};

const getIctFollowupPartialAnswersAsync = (followup_id, t) => async (dispatch) => {
  dispatch(setIctFollowupPartialAnswersData({}));
  dispatch(setIctDetailsLoading());
  try {
    const response = await ictDetailsService.getIctFollowupPartialAnswers(followup_id);
    if(response.status === 500){
      toast.error(t(1905));
      dispatch(setIctDetailsError(response));
    }
    else if (response?.data?.error || response?.data?.Error) {
      toast.error(t(response?.data?.error.error_code));
      dispatch(setIctDetailsError(response));
    }
    else {
      dispatch(setIctFollowupPartialAnswersData(response.data));
      dispatch(setIctDetailsError({}));
    }
  }
  catch(error) {
    dispatch(setIctDetailsError(error));
    return false;
  }
};

const addIctFollowupSubmitAnswersAsync = (followup_id, data, t, navigate) => async (dispatch) => {
  try{
    const response = await ictDetailsService.addIctFollowupSubmitAnswers(followup_id, data);
    if(response.status === 500){
      toast.error(t(1905));
      dispatch(setIctDetailsError(response));
      return false;
    }
    else if (response?.data?.error || response?.data?.Error) {
      toast.error(t(response?.data?.error.error_code));
      dispatch(setIctDetailsError(response));
      return false;
    }
    else {
      navigate(`/participants/ict/followups/${followup_id}/results`, { replace: true })      
      return true;
    }
  }
  catch(error) {
    dispatch(setIctDetailsError(error));
    return false;
  }
};

const getIctFollowupResponseAsync = (followup_id, t) => async (dispatch) => {
  dispatch(setIctDetailsLoading());
  try {
    const response = await ictDetailsService.getIctFollowupResponse(followup_id);
    if(response.status === 500){
      toast.error(t(1905));
      dispatch(setIctDetailsError(response));
    }
    else if (response?.data?.error || response?.data?.Error) {
      if(response.status === 400){
        toast.error(t(response?.data?.error.error_code));
      }
      dispatch(setIctDetailsError(response));
    }
    else {
      dispatch(setIctFollowupResponseData(response));
      dispatch(setIctDetailsError({}));
    }
  }
  catch(error) {
    dispatch(setIctDetailsError(error));
  }
};
const updateIctFollowupAnswerPageAsync = (followupId, dataToSave, t) => async (dispatch) => {
  try {
    const response = await ictDetailsService.updateIctFollowupAnswerPage(
      followupId,
      dataToSave,
    );
    if (response.status === 500) {
      toast.error(t(1905));
      dispatch(setIctDetailsError(response));
      return false;
    } else if (response?.data?.error || response?.data?.Error) {
      toast.error(t(response?.data?.error.error_code));
      dispatch(setIctDetailsError(response));
      return false;
    } else {
      dispatch(setIctDetailsError({}));
      return true;
    }
  } catch (error) {
    dispatch(setIctDetailsError(error));
    return false;
  }
};
export const IctDetailsAction = {
    getIctInventoryDetailsAsync,
    addIctInventoryAnswerAsync,
    getIctInventoryResultsAsync,
    getIctInventoryPartialAnswersAsync,
    addIctInventoryPartialAnswersAsync,
    UpdateIctInventoryAnswerPageAsync,
    getIctEvaluationDetailsAsync,
    addIctEvaluationAnswerAsync,
    getIctEvaluationPartialAnswersAsync,
    addIctEvaluationPartialAnswersAsync,
    getIctEvaluationResultsAsync,
    getIctFollowupDetailsAsync,
    addIctFollowupPartialAnswersAsync,
    getIctFollowupPartialAnswersAsync,
    addIctFollowupSubmitAnswersAsync,
    getIctFollowupResponseAsync,
    updateIctEvaluationAnswerPageAsync,
    updateIctFollowupAnswerPageAsync,
};